"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = jsOptions;
/* tslint:disable:no-eval */
const jquery_1 = __importDefault(require("jquery"));
/**
 * parses jsOptions "json" from <script type="application/json">.
 * Can contain functions and other JavaScript values like Date-Objects.
 * @see \Meeva\SmartAdminDatatableBundle\Helper\JavascriptEncoder
 */
function jsOptions($obj, def = {}) {
    if ((0, jquery_1.default)($obj).length) {
        const val = (0, jquery_1.default)($obj)[0].innerHTML;
        if (val) {
            try {
                return eval(`(function() { return ${val}; })()`);
            }
            catch (e) {
                console.error("Invalid jsOptions 'json': ", e);
            }
        }
    }
    return def;
}
